import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Shop from './pages/Shop';
import BestSellers from './pages/BestSellers';
import CategoryPage from './pages/CategoryPage';

const API_URL = "https://pro-erp-system.stacknet.lk/items/api/public";

const toSlug = (name) =>
  name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

function App() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch(API_URL)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setCategories(data.categories);
      })
      .catch(() => {});
  }, []);

  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/best-sellers" element={<BestSellers />} />

            {/* Dynamic category routes */}
            {categories.map((cat) => (
              <Route
                key={cat.name}
                path={`/${toSlug(cat.name)}`}
                element={<CategoryPage categoryName={cat.name} />}
              />
            ))}
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;